export default "__VITE_ASSET__DgrK8_sy__"